import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.classListFilter.loading;
export const selectErrorMessage = (state: RootState) =>
  state.classListFilter.error;
export const classListFilterDataResponse = (state: RootState) =>
  state.classListFilter.classFilterListResponse;
